import React from 'react';
import { Target } from 'lucide-react';
import { FormInputs } from '../types';

interface InputFormProps {
  inputs: FormInputs;
  setInputs: (inputs: FormInputs) => void;
  onGenerate: () => void;
  isLoading: boolean;
}

export function InputForm({ inputs, setInputs, onGenerate, isLoading }: InputFormProps) {
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Main Topic</label>
          <input
            type="text"
            value={inputs.topic}
            onChange={(e) => setInputs({ ...inputs, topic: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="e.g., Artificial Intelligence"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Target Keyword</label>
          <input
            type="text"
            value={inputs.keyword}
            onChange={(e) => setInputs({ ...inputs, keyword: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="e.g., machine learning trends"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Industry</label>
          <select
            value={inputs.industry}
            onChange={(e) => setInputs({ ...inputs, industry: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          >
            <option value="technology">Technology</option>
            <option value="health">Health</option>
            <option value="finance">Finance</option>
            <option value="education">Education</option>
            <option value="marketing">Marketing</option>
            <option value="ecommerce">E-commerce</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Audience Level</label>
          <select
            value={inputs.audience}
            onChange={(e) => setInputs({ ...inputs, audience: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          >
            <option value="beginner">Beginner</option>
            <option value="intermediate">Intermediate</option>
            <option value="advanced">Advanced</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Content Goal</label>
          <select
            value={inputs.goal}
            onChange={(e) => setInputs({ ...inputs, goal: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          >
            <option value="educational">Educational</option>
            <option value="commercial">Commercial</option>
            <option value="entertainment">Entertainment</option>
            <option value="buyer-intent">Buyer Intent</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Platform Focus</label>
          <select
            value={inputs.platform}
            onChange={(e) => setInputs({ ...inputs, platform: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          >
            <option value="blog">Blog</option>
            <option value="social">Social Media</option>
            <option value="email">Email</option>
          </select>
        </div>
      </div>

      <button
        onClick={onGenerate}
        disabled={!inputs.topic || !inputs.keyword || isLoading}
        className="w-full bg-indigo-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
      >
        <span className="flex items-center justify-center gap-2">
          <Target />
          {isLoading ? 'Generating...' : 'Generate Headlines'}
        </span>
      </button>
    </div>
  );
}